import './src/banner-silder';
import './src/brandlogo-carosuel';
import './src/product-collections';
import './src/testimonial-slider';
import './src/carousel-block';
import './src/timeline-slider';